import { render } from "./DollarIcon.vue?vue&type=template&id=37a3e482"
import script from "./DollarIcon.vue?vue&type=script&lang=js"
export * from "./DollarIcon.vue?vue&type=script&lang=js"
script.render = render

export default script